import { render, staticRenderFns } from "./HomeInfluencerPresetTabs.vue?vue&type=template&id=24bbd8d0&"
import script from "./HomeInfluencerPresetTabs.vue?vue&type=script&lang=js&"
export * from "./HomeInfluencerPresetTabs.vue?vue&type=script&lang=js&"
import style0 from "./HomeInfluencerPresetTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HomeInfluencerPresetTabs.vue"
export default component.exports